var exports = {
  "$P": "StreamSettingsMenuContent.module__modeItem___TUFLLX",
  "Q6": "StreamSettingsMenuContent.module__modeLabelColumn___TUFLLX",
  "i2": "StreamSettingsMenuContent.module__modeTitle___TUFLLX",
  "ED": "StreamSettingsMenuContent.module__modeDescription___TUFLLX",
  "nM": "StreamSettingsMenuContent.module__row___TUFLLX",
  "xZ": "StreamSettingsMenuContent.module__rowLabel___TUFLLX",
  "BE": "StreamSettingsMenuContent.module__premiumBadge___TUFLLX",
  "JV": "StreamSettingsMenuContent.module__audioDeviceLabel___TUFLLX",
  "ue": "StreamSettingsMenuContent.module__audioDeviceName___TUFLLX",
  "Ky": "StreamSettingsMenuContent.module__audioDeviceSubtext___TUFLLX",
  "HA": "StreamSettingsMenuContent.module__compactLiveGroupLabel___TUFLLX",
  "Au": "StreamSettingsMenuContent.module__audioDeviceIcon___TUFLLX",
};

module.exports = exports;
